const Aggression = require("../../entities/Aggression")
const {Age}  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class Occupy extends Aggression {
    constructor() {
        super(
            Age.Age3,
            AggessionNames.Occupy,
            3,
            "Take up to 3 resources, 3 food, 3 science, and 3 culture from your rival.",
            {
                //effect
            }
        )
    }
}

module.exports = Occupy;